import React, { forwardRef } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';

type Props = {
  className?: string;
};

export const AlternativeProposalsSeparatorDashed = forwardRef<HTMLDivElement, Props>(
  (props, ref) => (
    <div
      className={classnames('relative isolate flex w-full justify-center', props.className)}
      data-testid="AlternativeProposalsSeparatorDashed"
      ref={ref}
    >
      <hr className="absolute top-1/2 m-0 block h-1 w-full border-0 border-t-1 border-dashed border-grey p-0" />
      <p className="z-1 bg-white px-25 py-10 text-24 font-bold text-black">
        {t('booking.common.or')}
      </p>
    </div>
  ),
);
